import React, { useState, useEffect } from 'react';
import axios from 'axios';
import params from '../config/Params';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';

const GuestProfile = () => {
    const { userId } = useParams();
    const [userDetails, setUserDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        const fetchBookingDetails = async () => {
            setLoading(true);
            let formData = new FormData();
            formData.append('id', userId);
    
            try {
                const response = await axios({
                    method: 'post',
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    url: `${params.baseURL}${params.endpoints.getUserDetails}`,
                    data: formData
                });
    
                if (response.data.status === 'ok') {
                    setUserDetails(response.data.profile);
                } else {
                    setError('No guest profile found.');
                }
            } catch (err) {
                setError('An error occurred while fetching guest data.');
            } finally {
                setLoading(false);
            }
        };

        fetchBookingDetails();
    }, [userId]);

    if (loading) {
        return <p>Loading...</p>;
    }

    if (error) {
        return <p>No Guest Profile Found.</p>;
    }

    return (
        <div>
            <Helmet>
                <title>Guest Details</title>
                <meta name="description" content="" />
            </Helmet>

            <div className='booking-detail-section'>
                {userDetails && (
                    <>
                        <div className='category-img-section guest-image-section'>
                            <div className='gdpimgb'>
                                <img src={userDetails.customer_pic_image_url} alt='' className='img-fluid' />
                            </div>
                        </div>

                        <div class="guest-detail-section">
                            <div class="rating-info">
                                {userDetails.guest_pet_details?.data ? (
                                <div className="ri-box">
                                    <img src={userDetails.guest_pet_details.img} className="img-fluid" />
                                    <div className="ri-content-box">
                                    <span>{userDetails.guest_pet_details.data}</span>
                                    </div>
                                </div>
                                ) : (
                                <div className="ri-box">
                                    <img src={userDetails.guest_since.img} className="img-fluid" />
                                    <div className="ri-content-box">
                                    <span>{userDetails.guest_since.data}</span>
                                    </div>
                                </div>
                                )}
                                <div class="ri-box">
                                    <img src={userDetails.guest_average_rating.img} class="img-fluid" />
                                    <span class="ri-content-box">
                                        <span>{userDetails.guest_average_rating.data}</span>
                                    </span>
                                </div>
                                <div class="ri-box">
                                    <img src={userDetails.guest_review_count.img} class="img-fluid" />
                                    <span class="ri-content-box">
                                        <span>{userDetails.guest_review_count.data}</span>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div className='gds-box'>
                                <div className='gds-sub-box'>
                                    <img src={'/assets/img/icons/user_since_icon.svg'} alt="" className="bd-icon" />
                                    <p>{userDetails.customer_name}</p>
                                </div>
                                {/*<span className="line"></span>
                                <div className='gds-sub-box'>
                                    <img src={'/assets/img/icons/whatsapp_icon_r.svg'} alt="" className="bd-icon" />
                                    <p>{filteredBooking.customer_phone}</p>
                                </div>*/}
                                {userDetails.guest_pet_details?.data && (
                                <>
                                <span className="line"></span>
                                <div className='gds-sub-box'>
                                    <img src={'/assets/img/icons/user_since_icon.svg'} alt="" className="bd-icon" />
                                    <p>{userDetails.guest_since.data}</p>
                                </div>
                                </>
                                )}
                                <span className="line"></span>
                                <div className='gds-sub-box'>
                                    <img src={'/assets/img/icons/workplace_icon.svg'} alt="" className="bd-icon" />
                                    <p>My work: {userDetails.guest_workplace}</p>
                                </div>
                                <span className="line"></span>
                                <div className='gds-sub-box'>
                                    <img src={'/assets/img/icons/music_icon.svg'} alt="" className="bd-icon" />
                                    <p>Favourite song in high school: {userDetails.guest_fav_song}</p>
                                </div>
                                <span className="line"></span>
                                <div className='gds-sub-box'>
                                    <img src={'/assets/img/icons/live_location_icon.svg'} alt="" className="bd-icon" />
                                    <p>Lives in {userDetails.guest_living_location}</p>
                                </div>
                                <span className="line"></span>
                                <div className='gds-sub-box'>
                                    <img src={'/assets/img/icons/school_icon.svg'} alt="" className="bd-icon" />
                                    <p>Where i went to school: {userDetails.guest_school_name}</p>
                                </div>
                                <span className="line"></span>
                                <div className='gds-sub-box'>
                                    <img src={'/assets/img/icons/obsessed_icon.svg'} alt="" className="bd-icon" />
                                    <p>I'm obsessed with: {userDetails.guest_obsessed}</p>
                                </div>
                                <span className="line"></span>
                                <div className='gds-sub-box'>
                                    <img src={'/assets/img/icons/birhtday_icon.svg'} alt="" className="bd-icon" />
                                    <p>Born in the {userDetails.guest_born_decade}</p>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>

        </div>
    );
};

export default GuestProfile;
